import React from "react";

interface TermsProps {
  additionalClassName?: string;
}
const Terms: React.FC<TermsProps> = ({ additionalClassName }) => {
  const linkStyle = "underline font-medium";
  return (
    <p className={`bg-transparent text-left text-sm ${additionalClassName ?? ""}`} data-testid="terms_privacy">
      By confirming, you accept our{" "}
      <a href="/pages/termsofservice" className={linkStyle}>
        Terms of Service
      </a>{" "}
      and{" "}
      <a href="/privacy" className={linkStyle}>
        Privacy Policy
      </a>
      .
    </p>
  );
};

export default Terms;
